module.exports = __webpack_public_path__ + "img/3.6e6dc655.png";